import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-org-view',
  templateUrl: './org-view.component.html',
  styleUrls: ['./org-view.component.css']
})
export class OrgViewComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
